import { connectModal } from "redux-modal";
import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import RentContractDeviceForm from "../../Forms/RentContractDeviceForm/RentContractDeviceForm";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";

const RentContractDeviceModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:rentContractDevice.information"), error: false },
    { title: t("global:rentContractDevice.additional"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "RentContractDeviceForm";
  const { handleHide, show, view } = props;

  const buttons = () => {
    return (
      <>
        {!view ? (
          <BMXButton
            data-cy="save"
            type="subbmit"
            onClick={() => setIsSubmit(true)}
            bmxclass="Success"
            form={formName}
          >
            {t("global:save")}
          </BMXButton>
        ) : null}
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"1100px"}
      height={"760px"}
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <RentContractDeviceForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "RentContractDeviceModal" })(
  RentContractDeviceModal
);
